import { showDropdownSidebarCategory } from '@/event/main/navbar/showDropdownSidebarCategory'
import { showDropdownSidebarSiteMap } from '@/event/main/navbar/showDropdownSidebarSitemap'

export function toggleDropdownSidebarCategory() {
  showDropdownSidebarCategory.value = !showDropdownSidebarCategory.value
  if (showDropdownSidebarSiteMap.value == true) {
    showDropdownSidebarSiteMap.value = false
  }
}
